// extracted by mini-css-extract-plugin
export default {"settings_container":"OrgSettings_settings_container__cFLUl","settings_input":"OrgSettings_settings_input__R9GRK"};